import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { persistor } from '@/App/store'; // Fix: Import persistor
import { 
  LOGOUT,
  logout as logoutAction, 
  setCurrentUser, 
  setCurrentAccount 
} from './authSlice';
import { internalApi, REACT_APP_SSO_URI } from '@/utils/request';
import { selectAuthUser } from './selectors';

const MARKETING_URL = process.env.REACT_APP_MARKETING_APP || 'https://noviopus.com';

// Ensure SSO URI is defined here as well for the direct axios call
const SSO_API = REACT_APP_SSO_URI || 'https://sso.noviopus.com/api';

// --- Reusable Saga to Refresh User & Account State ---
export function* fetchUserWithAccount() {
  try {
    let user = yield select(selectAuthUser);
    
    // 1. Fetch/Verify User
    if (!user) {
       const response = yield call(internalApi.get, '/business/current-user');
       if (response && (response.status === 200 || response.id)) {
          user = response.data || response;
          yield put(setCurrentUser(user));
       } else {
          return null; 
       }
    }

    // 2. Fetch Accounts
    try {
        const accountsResponse = yield call(internalApi.get, `/users/${user.id}/accounts`);
        const accountsData = accountsResponse.data || accountsResponse;
        
        if (accountsData && Array.isArray(accountsData) && accountsData.length > 0) {
          const account = accountsData[0];
          yield put(setCurrentAccount(account));
          return { user, account };
        } 
    } catch (apiError: any) {
        if (apiError.response && apiError.response.status === 404) {
            yield put(setCurrentAccount(null));
            return { user, account: null };
        }
        console.warn('[AuthSaga] Account fetch failed', apiError);
    }
    
    // Default: No account found
    yield put(setCurrentAccount(null));
    return { user, account: null };
    
  } catch (e) {
    console.error('[AuthSaga] Fetch user context failed', e);
    return null;
  }
}

function* logoutFlow() {
  try {
      // Direct call to SSO signout
      yield call(axios.post, `${SSO_API}/users/signout`, {}, { withCredentials: true });
      console.log('SSO Signout successful');
  } catch (e) {
      console.warn('SSO Signout API failed, proceeding with local cleanup.', e);
  } finally {
      // --- BLUEPRINT FIX: Purge Persistence ---
      // This matches Career App logic to prevent state conflicts on next login
      try {
        yield call([persistor, persistor.purge]);
      } catch (err) {
        console.error('Persistor purge failed', err);
      }

      // Reset Redux State
      yield put(logoutAction());
      
      // Force Hard Redirect
      window.location.href = MARKETING_URL;
  }
}

export default function* authRootSaga() {
  yield takeLatest(LOGOUT, logoutFlow);
}